import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { INguonBietToiActionTypes } from "../../action-types/crm-category/IDmNguonBietToiActionTypes";
import { IDmNguonBietToiReducer } from "../../page-state-model/crm-category/IDmNguonBietToiReducer";
const iniState: IDmNguonBietToiReducer = {
    status: ePageBaseStatus.is_not_initialization,
    nguonBietTois: []
}
export const nguonBietToiReducer = (state: IDmNguonBietToiReducer = iniState, action: INguonBietToiActionTypes): IDmNguonBietToiReducer => {
    switch (action.type) {
        case "NGUON_BIET_TOI_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "NGUON_BIET_TOI_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                nguonBietTois: action.payload
            }
        case "NGUON_BIET_TOI_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                nguonBietTois: []
            }
        case "NGUON_BIET_TOI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "NGUON_BIET_TOI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "NGUON_BIET_TOI_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "NGUON_BIET_TOI_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "NGUON_BIET_TOI_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "NGUON_BIET_TOI_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "NGUON_BIET_TOI_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "NGUON_BIET_TOI_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}